export default "__VITE_ASSET__CztxyBR4__"